import styled from 'styled-components';
import { SIZE, FONTS, COLORS } from '@app/src/ui';

interface Props {
  isBold?: boolean;
  color?: string;
}

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

Box.displayName = 'Box';

export const PaymentSummary = styled.div`
  margin-top: 10px;
  font-family: ${FONTS.OPEN_SANS};
  padding: 4px 6px;
  background-color: ${(props: Props) => props.color};
  border-radius: 4px;
  width: 100%;
  font-size: 12px;

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

PaymentSummary.displayName = 'PaymentSummary';

export const SummaryDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin: 4px 0;
`;

SummaryDescription.displayName = 'SummaryDescription';

export const TextDescription = styled.div`
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
`;

TextDescription.displayName = 'TextDescription';

export const Wrapper = styled.div`
  position: relative;
  position: relative;
  max-width: 420px;
  margin: 0 auto;
  padding: 0 15px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
    margin: inherit;
  }
`;

Wrapper.displayName = 'Wrapper';

export const SectionTitle = styled.h3`
  font-family: ${FONTS.ROBOTO};
  font-size: 15px;
  letter-spacing: 1px;
  padding: 0 12px;
  line-height: 34px;
  border-radius: 3px;
  background-color: ${(props: Props) => props.color};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 516px;
  }
`;

SectionTitle.displayName = 'SectionTitle';

export const OperationType = styled.span`
  text-transform: lowercase;
  font-weight: 400;
`;

OperationType.displayName = 'OperationType';

export const Separator = styled.div`
  border-top: 1px solid ${COLORS.BLACK_BOLD};
  margin-top: 6px;
`;

Separator.displayName = 'Separator';
